import React from "react";
import "./GuessScoreModal.css";
import "../homeDashboard/DashboardSkeleton.css";

function GuessScoreModal({
  open,
  onClose,
  activeView = "subject",
  onToggleView,
  subjectTitle = "",
  subjectSubtitle = "",
  subjectSummary = {},
  isSubjectLoading = false,
  allSubjectsSummary = {},
  isAllSubjectsLoading = false,
}) {
  if (!open) {
    return null;
  }

  const isAllSubjectsView = activeView === "all";
  const activeSummary = isAllSubjectsView ? allSubjectsSummary : subjectSummary;
  const isLoading = isAllSubjectsView ? isAllSubjectsLoading : isSubjectLoading;

  const {
    score = "0%",
    guessQuestions = 0,
    rightGuess = 0,
    wrongGuess = 0,
  } = activeSummary || {};
  const title = isAllSubjectsView ? "All Subjects" : subjectTitle || "General";
  const subtitle = isAllSubjectsView
    ? "Overall Guess Score"
    : subjectSubtitle || "Guess Score Overview";
  const actionLabel = isAllSubjectsView
    ? subjectTitle || "Back to Subject Score"
    : "View overall Guess Score";

  return (
    <div className="guess-score-overlay" onClick={onClose} role="presentation">
      <div
        className="guess-score-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Guess Score"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="guess-score-modal__close"
          onClick={onClose}
          aria-label="Close guess score modal"
        >
          {"\u00D7"}
        </button>

        <div className="guess-score-modal__header">
          <div className="guess-score-modal__headerCopy">
            {isLoading ? (
              <>
                <span className="dashboard-skeleton dashboard-skeleton--title guess-score-modal__shimmer-title" />
                <span className="dashboard-skeleton dashboard-skeleton--text guess-score-modal__shimmer-subtitle" />
              </>
            ) : (
              <>
                <h3 className="guess-score-modal__title">
                  {title || "General"} <span>Score</span>
                </h3>
                <p className="guess-score-modal__subtitle">{subtitle || "Guess Score Overview"}</p>
              </>
            )}
          </div>
          {isLoading ? (
            <span className="dashboard-skeleton dashboard-skeleton--button guess-score-modal__shimmer-score" />
          ) : (
            <div className="guess-score-modal__score">{score}</div>
          )}
        </div>

        <div className="guess-score-modal__stats">
          {isLoading ? (
            Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="guess-score-modal__row guess-score-modal__row--loading">
                <span className="dashboard-skeleton dashboard-skeleton--text guess-score-modal__shimmer-rowLabel" />
                <span className="dashboard-skeleton dashboard-skeleton--line guess-score-modal__shimmer-rowValue" />
              </div>
            ))
          ) : (
            <>
              <div className="guess-score-modal__row">
                <span>Guess Questions</span>
                <strong>{guessQuestions}</strong>
              </div>
              <div className="guess-score-modal__row is-correct">
                <span>Right Guess</span>
                <strong>{rightGuess}</strong>
              </div>
              <div className="guess-score-modal__row is-wrong">
                <span>Wrong Guess</span>
                <strong>{wrongGuess}</strong>
              </div>
            </>
          )}
        </div>

        {isLoading ? (
          <div className="guess-score-modal__copy">
            <span className="dashboard-skeleton dashboard-skeleton--text guess-score-modal__shimmer-copy" />
            <span className="dashboard-skeleton dashboard-skeleton--text guess-score-modal__shimmer-copy guess-score-modal__shimmer-copy--short" />
          </div>
        ) : (
          <p className="guess-score-modal__copy">
            While taking a test or practicing questions, you can mark the questions you
            are answering by guessing and review the overall performance later.
          </p>
        )}

        {isLoading ? (
          <span className="dashboard-skeleton dashboard-skeleton--button guess-score-modal__shimmer-button" />
        ) : (
          <button type="button" className="guess-score-modal__action" onClick={onToggleView}>
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
}

export default GuessScoreModal;
